import type { CSSProperties } from 'react'
import css from './StatusColorSquare.module.css'

interface StatusColorSquareProps {
    color?: string | null
}

const StatusColorSquare = ({ color }: StatusColorSquareProps) => {
    const style = { '--status-color': color ?? '#FFFFFF' } as CSSProperties
    return <div className={css.square} style={style} />
}

export default StatusColorSquare
